import { Component, computed, input } from '@angular/core';
import { PlanName } from '../helpers';

@Component({
  selector: 'app-pan-plan-name',
  templateUrl: './pan-plan-name.component.html',
  styleUrl: './pan-plan-name.component.scss',
  standalone: false,
})
export class PanPlanNameComponent {
  public planName = input.required<PlanName>();

  public planClass = computed(() => this.planName().toLowerCase());

  public label = computed(() => {
    switch (this.planName()) {
      case 'noplan':
        return 'no theft plan';
      case 'flexprotect':
        return 'flex protect';
      case 'per-instance':
        return 'per instance';
      default:
        return this.planName();
    }
  });
}
